/* eslint-disable @typescript-eslint/no-explicit-any */
import videojs from "video.js";

let registered = false;

const RATES = [0.75, 1, 1.25, 1.5, 1.75, 2];

function formatRate(r: number): string {
  const fixed = Math.round(r * 100) / 100;
  return `${fixed}${fixed === 1 ? "" : ""}x`;
}

export function registerVideoJsSpeedCycleButton(): void {
  if (registered) return;
  registered = true;

  const Button = videojs.getComponent("Button") as any;

  class SpeedCycleButton extends Button {
    constructor(player: any, options?: any) {
      super(player, options);
      this.controlText("سرعة الفيديو");
    }

    createEl() {
      const el = super.createEl();
      el.classList.add("vjs-speed-cycle");

      const label = document.createElement("span");
      label.className = "vjs-speed-cycle-label";
      label.textContent = "1x";
      el.appendChild(label);

      return el;
    }

    handleClick() {
      const p = this.player();
      const current = Number(p.playbackRate?.() ?? 1) || 1;
      const idx = RATES.findIndex((x) => Math.abs(x - current) < 0.001);
      const next = RATES[(idx >= 0 ? idx : 1) + 1] ?? RATES[0];
      p.playbackRate(next);
      this.update();
    }

    update() {
      const p = this.player();
      const r = Number(p.playbackRate?.() ?? 1) || 1;
      const label: HTMLElement | null = this.el()?.querySelector?.(".vjs-speed-cycle-label") ?? null;
      if (label) label.textContent = formatRate(r);
    }

    buildCSSClass() {
      return `vjs-speed-cycle ${super.buildCSSClass()}`;
    }
  }

  (videojs as { registerComponent: (n: string, c: unknown) => void }).registerComponent(
    "SpeedCycleButton",
    SpeedCycleButton
  );
}

export function addSpeedCycleButtonToControlBar(player: any): void {
  player.ready(() => {
    const cb = player?.controlBar;
    if (!cb) return;

    // Remove default playback rate menu if present.
    const pr = cb.getChild?.("playbackRateMenuButton");
    if (pr) {
      cb.removeChild?.(pr);
    }

    // Insert near the right side: before fullscreen toggle if exists, else at end.
    const fullscreen = cb.getChild?.("fullscreenToggle");
    const idx = fullscreen ? cb.children().indexOf(fullscreen) : cb.children().length;

    if (!cb.getChild?.("SpeedCycleButton")) {
      cb.addChild("SpeedCycleButton", {}, Math.max(0, idx));
    }

    // Keep label in sync.
    const btn = cb.getChild?.("SpeedCycleButton");
    btn?.update?.();
    player.on?.("ratechange", () => btn?.update?.());
  });
}

